module.exports = __webpack_public_path__ + "media/images/cvv-0aa49b23da7ebe2fc67d617d9f9238d4.jpg";